import React, { useState } from "react";
import { ScrollArea } from "../../../../components/ui";
import { formatThaiDate } from "../utils";
import { FaPlus } from "react-icons/fa";

export const OrderNotes = ({ order, callApi, toastSuccess, toastError }) => {
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  const addNote = async () => {
    if (!note.trim()) return;
    if (!window.confirm("ต้องการเพิ่มโน้ตใช่หรือไม่?")) return;

    setLoading(true);
    try {
      const { status, message } = await callApi(
        "orders-updateNotes",
        { orderId: order.id, note: note.trim() },
        { notShowLoading: true }
      );
      if (status) {
        toastSuccess();
        setNote("");
      } else {
        toastError(message || "เพิ่มโน้ตไม่สำเร็จ");
      }
    } finally {
      setLoading(false);
    }
  };

  const allNotes = [...(order?.notes || []), ...(order?.note || [])]
    .filter((n) => {
      if (!n || !n.note) return false;
      if (
        typeof n.note === "string" &&
        (n.note.startsWith("working =") || n.note.includes("[object Object]"))
      ) {
        return false;
      }
      return true;
    })
    .sort((a, b) => b.time - a.time);

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between gap-3 pb-3 mb-3 border-b border-slate-200">
        <h4 className="font-bold text-lg text-slate-800">โน้ตข้อความ</h4>
      </div>

      <div className="flex gap-2 mb-3">
        <input
          type="text"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              addNote();
            }
          }}
          placeholder="พิมพ์ข้อความโน้ต..."
          disabled={loading}
          className="w-full h-9 px-3 text-sm font-medium border border-slate-300 rounded-md bg-white text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 disabled:bg-slate-100"
        />
        <button
          type="button"
          disabled={loading || !note.trim()}
          onClick={addNote}
          className="bg-green hover:opacity-90 disabled:opacity-50 text-white font-bold h-9 px-3.5 rounded-md text-xs flex items-center gap-1.5 transition-all shadow-xs whitespace-nowrap cursor-pointer"
        >
          {loading ? (
            <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            <>
              <FaPlus className="text-[10px]" />
              <span>เพิ่ม</span>
            </>
          )}
        </button>
      </div>

      <ScrollArea className="h-[400px]">
        {allNotes.length > 0 ? (
          <div className="flex flex-col gap-2.5 pr-3">
            {allNotes.map((n, idx) => (
              <div
                key={n.time || idx}
                className="bg-blue text-white p-3 rounded-md shadow-xs"
              >
                <div className="flex items-center justify-between gap-2 border-b border-white/20 pb-1 mb-1.5">
                  <p className="text-sm font-bold truncate">{n.by || "System"}</p>
                  <p className="text-[11px] font-medium text-white/80 whitespace-nowrap">
                    {formatThaiDate(n.time)}
                  </p>
                </div>
                <p className="text-xs font-medium leading-relaxed break-words">
                  {n.note}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <div className="h-32 flex justify-center items-center rounded-md border border-dashed border-slate-200 bg-slate-50/50">
            <p className="text-sm font-semibold text-slate-400">ไม่พบข้อมูลโน้ต</p>
          </div>
        )}
      </ScrollArea>
    </div>
  );
};
